/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type LotDisplayStatus = "available" | "not_set" | "reserved" | "sold";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentProductDetails_product$ref: FragmentReference;
declare export opaque type DevelopmentProductDetails_product$fragmentType: DevelopmentProductDetails_product$ref;
export type DevelopmentProductDetails_product = {|
  +salePrice: ?number,
  +lotReference: ?string,
  +displayStatus: LotDisplayStatus,
  +hidePriceOnPortals: ?boolean,
  +property: {|
    +livingSurface: ?number,
    +usableSurface: ?number,
    +grossFloorSurface: ?number,
    +gardenSurface: ?number,
    +terraceSurface: ?number,
    +balconySurface: ?number,
    +landSurface: ?number,
    +basementSurface: ?number,
    +weightedFloorSurface: ?number,
    +buildingVolume: ?number,
    +numberOfRooms: ?number,
    +numberOfBedrooms: ?number,
    +numberOfBathrooms: ?number,
    +numberOfToilets: ?number,
    +floorOfFlat: ?number,
    +constructionYear: ?number,
    +renovationYear: ?number,
    +numberOfIndoorParkings: ?number,
    +numberOfOutdoorParkings: ?number,
  |},
  +$refType: DevelopmentProductDetails_product$ref,
|};
export type DevelopmentProductDetails_product$data = DevelopmentProductDetails_product;
export type DevelopmentProductDetails_product$key = {
  +$data?: DevelopmentProductDetails_product$data,
  +$fragmentRefs: DevelopmentProductDetails_product$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentProductDetails_product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lotReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hidePriceOnPortals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Property",
      "kind": "LinkedField",
      "name": "property",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "livingSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usableSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "grossFloorSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gardenSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "terraceSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balconySurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "landSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "basementSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weightedFloorSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "buildingVolume",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfRooms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfBedrooms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfBathrooms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfToilets",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "floorOfFlat",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "constructionYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "renovationYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfIndoorParkings",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfOutdoorParkings",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '7cd9dab5577790c7953294d2f627ede4';

export default node;
